import { render, staticRenderFns } from "./white.vue?vue&type=template&id=0106aa0c&scoped=true&"
import script from "./white.vue?vue&type=script&lang=js&"
export * from "./white.vue?vue&type=script&lang=js&"
import style0 from "./white.vue?vue&type=style&index=0&id=0106aa0c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0106aa0c",
  null
  
)

export default component.exports